import React, { useEffect, useState } from "react";
import { Grid } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import {
  ButtonAddHLPure,
  ButtonHLPure,
  GridHLPure,
  ValidateInputPure,
  SimpleLoading,
  TextBoxHLPure,
  SequentialSigner,
  DialogSystemGLPure,
  DialogTemplatePure,
  DialogYesNoHLPure,
  CardCircularProgressBarHLPure,
  LabelModalPure
} from "../../pures";
import { ContractService, QuestionnaireService } from "../../../services";
import { NIL as NIL_UUID } from "uuid";
import "./questionnaires-administration-manage-questions.view.css";
import QuestionsPure from "./questionsPure";
import LabelPure from "../../pures/label/label.pure";

const QuestionnairesAdministrationManageQuestionsView = ({
  selectedQuestionnaire,
  token,
  user,
  showDetailComponent,
  toggleShowDetailComponent,
  hideShowDetails,
  setShowDetails,
  setNameComponentUser,
  nameComponentUser,
  setselectedQuestions,
  setVariablesForQuestionnaire,
  setVariablesToShow,
  setAllInfoQuestionToSend,
  allInfoQuestionToSend,
  toggleErrorRequesting,
  toggleLoadingRequesting,
  toggleCompletedRequesting,
  showCompletedRequesting,
  showErrorRequesting,
  showLoadingRequesting,
  allInfoQuestionToSendStirng,
  setAllInfoQuestionToSendStirng,
  errorInfoQuestions,
  questionsBeforeSend,
  setQuestionsBeforeSend
}) => {
  const { t } = useTranslation();

  const [showGettingData, setShowGettingData] = useState(false);
  const [templateVarNumbers, setTemplateVarNumbers] = useState(0);
  const [useVarNumbers, setUseVarNumbers] = useState(0);
  const [questions, setQuestions] = useState([]);
  const [typeQuestions, setTypeQuestions] = useState([]);
  const [dataSigners, setDataSigners] = useState([]);
  const [allVariablesFormBd, setAllVariablesFromBd] = useState([]);
  const [varsUsed, setVarsUsed] = useState([]);
  const [showDialogDeleteQuestion, setShowDeleteQuestion] = useState(false)
  const [questionToDelete, setQuestionToDelete] = useState({})
  const [isLoading, setIsLoading] = useState(false);

  const stylesCirclebar = {
    width: "45px",
    height: "45px"
  }
  // get all templates
  const getAllTemplates = async () => {
    let clientId = user.userMetaData.userA3Cloud.clientId;
    let questionnaireService = new QuestionnaireService(
      process.env.REACT_APP_MIFIRMA_API
    );
    try {
      let templates =
        await questionnaireService.getAllTemplatesByCompaniIdAndClienId(
          clientId,
          null,
          token
        );
      if (Number(templates.status) === 200) {
        let temeplateSelected = templates.data.data.filter((template) => {
          return template.id === selectedQuestionnaire.template.id;
        });
        let variables = []
        let variablesNumber = 0
        if (temeplateSelected && temeplateSelected.length > 0) {
          variables = temeplateSelected[0].templateVariable;
          variablesNumber = temeplateSelected[0].templateVariable.length;
        }
        setTemplateVarNumbers(variablesNumber);
        setAllVariablesFromBd(variables);
      }
    } catch (error) {
      await toggleErrorRequesting(true);
      setTimeout(() => {
        toggleErrorRequesting(false);
      }, 2000);
      window.location.reload();
    }
  };

  //get all questions by questionnaireId was selected
  const getQuestions = async () => {
    setShowGettingData(true);
    let questionnaireId = selectedQuestionnaire
      ? selectedQuestionnaire.id
      : NIL_UUID;
    let questionnaireService = new QuestionnaireService(
      process.env.REACT_APP_MIFIRMA_API
    );
    try {
      let completeInfoQuestions = await questionnaireService.getCompleteInfoQuestions(questionnaireId, token)
      let questionsToShowCompelte = []
      for (let index = 0; index < completeInfoQuestions.data.length; index++) {
        if (completeInfoQuestions && completeInfoQuestions.data && index > 0 && completeInfoQuestions.data[index].Question) {
          questionsToShowCompelte.push(completeInfoQuestions.data[index].Question)
        }
      }

      // let allQuestionAnswers = {
      //   "questionAnswer" : []
      // }
      // let questionAnswer = []
      // for (let i = 0; i < completeInfoQuestions.data[1].Questions.length; i++) {
      //   questionsToShowCompelte.push(completeInfoQuestions.data[1].Questions[i].question)
      //   let number1 = 1 + i
      //   let number2 = 0
      //   let number3 = 0
      //   completeInfoQuestions.data[1].Questions[i].question.consecutive = number1+ "."+number2 +"."+number3;
      //   completeInfoQuestions.data[1].Questions[i].question.questionGroup = completeInfoQuestions.data[1].Questions[i].question.question + completeInfoQuestions.data[1].Questions[i].question.order;
      //   questionAnswer.push(completeInfoQuestions.data[1].Questions[i])
      // }

      // questionAnswer.sort(function (a, b){
      //   return (a.question.consecutive - b.question.consecutive)
      // })
      // questionsToShowCompelte.sort(function (a, b){
      //   return (a.consecutive - b.consecutive)
      // })
      // let datoQuestion = allQuestions.data[i] && allQuestions.data[i].fieldType ? allQuestions.data[i].fieldType.name : 'text'
      // let questionPush = {}
      // questionPush.question = {}
      // questionPush.answer = {}
      // questionPush.dato = datoQuestion
      // questionPush.id = ''
      // questionPush.questionId = ''
      // questionPush.answerId = ''
      // questionPush.notes = ''
      // questionPush.question.id = allQuestions.data[i].id
      // questionPush.question.questionnaireId = allQuestions.data[i].questionnaireId
      // questionPush.question.fieldTypeId = allQuestions.data[i].fieldTypeId
      // questionPush.question.fieldType = allQuestions.data[i].fieldType
      // questionPush.question.order =  i + 1
      // questionPush.question.level =  1
      // questionPush.question.questionGroup = allQuestions.data[i].question + "-" + questionPush.question.order
      // questionPush.question.question =  allQuestions.data[i].question
      // questionPush.question.helpText =  allQuestions.data[i].helpText
      // questionPush.question.requireClientDocument = false
      // questionPush.question.requireTemplateVariable = false
      // questionPush.question.questionClientDocument = []
      // questionPush.answer.id = ''
      // questionPush.answer.templateVariableId = varId
      // questionPush.answer.answerSelected = false
      // questionPush.answer.answer = ''
      // questionPush.answer.monetaryUnit = {}
      // // allQuestionAnswers.questionsAnswer.push(questionPush)
      // questionAnswer.push(questionPush)

      // allQuestions.data[i].dato = datoQuestion;
      // allQuestions.data[i].order = i + 1;
      // allQuestions.data[i].questionGroup =
      //   allQuestions.data[i].question + "-" + allQuestions.data[i].order;
      // allQuestions.data[i].level = 1;
      // allQuestions.data[i].questionsLevel2 = [];
      // allQuestions.data[i].questionsLevel3 = [];
      // let questionsToDrop =
      //   allQuestions && Number(allQuestions.statusCode) === 200
      //     ? allQuestions.data
      //     : [];
      // allQuestionAnswers.questionAnswer = questionAnswer

      // lines to add all info to questionnaire
      // const questionJson =  JSON.stringify(allQuestionAnswers)
      // setAllInfoQuestionToSendStirng(questionJson);
      setQuestions(questionsToShowCompelte);
      setAllInfoQuestionToSend(questionsToShowCompelte)
      getAllVarsUseInQuestions(questionsToShowCompelte);

      setTimeout(() => {
        setShowGettingData(false);
      }, 3000);
    } catch (error) {
      setShowGettingData(false);
      await toggleErrorRequesting(true);
      setTimeout(() => {
        toggleErrorRequesting(false);
      }, 2000);
      // window.location.reload();
    }
  };

  //get all variables are use in questions
  const getAllVarsUseInQuestions = (questions) => {
    let varsWasUse = [];
    let vars = [];
    if (questions && questions.length > 0) {
      for (let index = 0; index < questions.length; index++) {
        let allAnswers = questions[index].answers
        for (let j = 0; j < allAnswers.length; j++) {
          if (allAnswers[j].answer.templateVariableId > 0) {
            vars = allAnswers[j].answer.templateVariableId;
            varsWasUse.push(vars);
          }
        }
      }
      setUseVarNumbers(varsWasUse.length);
      setVarsUsed(varsWasUse);
    } else {
      setUseVarNumbers(0);
      setVarsUsed(varsWasUse);
    }
  };

  useEffect(() => {
    if (nameComponentUser === t("questionnairesAdministrationView.btn.adm.questions.grid")) {
      getQuestions();
      getAllTemplates();

    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);

  //SET variables that was use and pass to component edit question
  useEffect(() => {
    let copyVariables = [...allVariablesFormBd];
    let variablesNotPass = [];
    if (varsUsed.length > 0) {
      for (let i = 0; i < varsUsed.length; i++) {
        let variableAdd = copyVariables.filter(
          (variable) => variable.id === varsUsed[i]
        );
        variablesNotPass.push(variableAdd[0]);
      }
      var variablesToShow = copyVariables.filter(
        (el) => !variablesNotPass.includes(el)
      );

      setVariablesToShow(variablesToShow);
      setVariablesForQuestionnaire(allVariablesFormBd);
    } else {
      setVariablesToShow(allVariablesFormBd);
      setVariablesForQuestionnaire(allVariablesFormBd);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [allVariablesFormBd, varsUsed]);

  const changeUpDownRows = async (dataItem, sum, key) => {
    // setQuestionsBeforeSend(questions)
    let idsIndex = [];
    //save info if ocurred an error
    let questionsBefore = Object.assign({}, questions);
    let consecutivesQuestions = []
    for (let u = 0; u < questions.length; u++) {
      consecutivesQuestions.push(questions[u].consecutive)
    }

    const index = questions.findIndex(
      (question) => question.id === dataItem.id
    );
    let numToSplice = Number(sum) === 1 ? index + 1 : index - 1;
    let addQuestion = questions.filter((question) => {
      return question.question === dataItem.question;
    });


    if (
      (numToSplice === -1 && Number(sum) === -1) ||
      (numToSplice === questions.length && Number(sum) === 1) ||
      dataItem.level > 1
    ) {
      return;
    }

    let newArrQuestions = questions.filter(
      (signer) => signer.question !== dataItem.question
    );
    newArrQuestions.splice(numToSplice, 0, addQuestion[0]);

    let count = 0;
    for (let i = 0; i < newArrQuestions.length; i++) {
      if (newArrQuestions[i].level === 1) {
        let numberConsec1 = count + 1
        let numberConsec2 = 0
        let numberConsec3 = 0
        newArrQuestions[i].consecutive = numberConsec1 + '.' + numberConsec2 + '.' + numberConsec3;
        count++;
      }
      // } else {
      //   let splitNum = newArrQuestions[i].order.split(".");
      //   let firstNumber = Number(splitNum[0]) - 1;
      //   let secNumber = splitNum[1];
      //   let preOrder =  `${firstNumber}.${secNumber}`
      //   newArrQuestions[i].order = Number(preOrder);
      //   idsIndex.push(newArrQuestions[i].id);
      // }
    }

    // for (let i = 0; i < idsIndex.length; i++) {
    //   let idx = newArrQuestions.findIndex(
    //     (question) => question.id === idsIndex[i]
    //   );
    //   let moveQuestion = newArrQuestions.filter(
    //     (question) => question.id === idsIndex[i]
    //   );
    //   let numIdx = idx - 1;
    //   let questionFinal = newArrQuestions.filter(
    //     (question) => question.id !== moveQuestion[0].id
    //   );
    //   questionFinal.splice(numIdx, 0, moveQuestion[0]);
    //   newArrQuestions = questionFinal;
    // }
    updateOrderIdLevelQuestions(newArrQuestions, questionsBefore, consecutivesQuestions)
    // orderJsonByQuestions(newArrQuestions)
  };

  const changeRightLeftRows = async (dataItem, sum) => {
    let copyQuestions = [...questions];
    let copyQuestionsToSplice = [...questions];

    //save info if ocurred an error
    let questionsBefore = Object.assign({}, questions);
    let consecutivesQuestions = []
    for (let u = 0; u < questions.length; u++) {
      consecutivesQuestions.push(questions[u].consecutive)
    }


    let questionSelect = copyQuestions.filter(
      (question) => question.id === dataItem.id
    );
    let index = questions.findIndex((question) => question.id === dataItem.id);
    if (index === 0 || (index === questions.length && Number(sum) === 1)) {
      return;
    }

    let indexQuestionBase = index - 1;
    let questionBasic = copyQuestionsToSplice.splice(indexQuestionBase, 1);
    let splitConsecutive = questionBasic[0].consecutive.split('.')
    let conseNumber1 = Number(splitConsecutive[0])
    let conseNumber2 = Number(splitConsecutive[1])
    let conseNumber3 = Number(splitConsecutive[2])
    // if (questionBasic[0].level > 1) {
    //   let questionLevelOne = copyQuestions.filter(
    //     (question) =>
    //       question.level === 1 &&
    //       question.questionGroup === questionBasic[0].questionGroup
    //   );
    //   questionBase = questionLevelOne;
    // } else {
    //   questionBase = questionBasic;
    // }

    if (Number(sum) === 1) {
      if (dataItem.level === 1) {
        questionSelect[0].questionGroup = questionBasic[0].questionGroup;
        questionSelect[0].level = 2;
        questionSelect[0].order = conseNumber1;
        let consecutive1 = conseNumber1
        let consecutive2 = conseNumber2 + 1
        let consecutive3 = 0
        questionSelect[0].consecutive = consecutive1 + "." + consecutive2 + "." + consecutive3;
        // let numberOrder = parseInt(questionBase[0].questionsLevel2.length + 1);
        // let preOrder = `${questionBase[0].order}.${numberOrder}`
        // questionBase[0].questionsLevel2.push(questionSelect[0]);
      } else if (dataItem.level === 2) {
        if (questionBasic[0].level === 1) {
          return;
        }
        // let indexRemove = questionBasic[0].questionsLevel2.findIndex(
        //   (question) => question.id === dataItem.id
        // );
        // let questionRemoved = questionBasic[0].questionsLevel2.splice(
        //   indexRemove,
        //   1
        // );
        questionSelect[0].questionGroup = questionBasic[0].questionGroup;
        questionSelect[0].level = 3;
        questionSelect[0].order = conseNumber1;
        // let orderBasic = questionBasic[0].order + ".1"
        let consecutive1 = conseNumber1
        let consecutive2 = conseNumber2
        let consecutive3 = conseNumber3 + 1
        questionSelect[0].consecutive = consecutive1 + "." + consecutive2 + "." + consecutive3;
        // questionBasic[0].questionsLevel3.push(questionSelect[0]);
      } else {
        return;
      }
      let count = 0;
      for (let i = 0; i < copyQuestions.length; i++) {
        if (copyQuestions[i].level === 1) {
          let numberConsec1 = count + 1
          let numberConsec2 = 0
          let numberConsec3 = 0
          copyQuestions[i].consecutive = numberConsec1 + '.' + numberConsec2 + '.' + numberConsec3;
          count++;
        }
      }
      copyQuestions.splice(index, 1, questionSelect[0]);
      updateOrderIdLevelQuestions(copyQuestions, questionsBefore, consecutivesQuestions)
    } else {
      if (dataItem.level === 3) {
        // let indexRemove = questionBasic[0].questionsLevel3.findIndex(
        //   (question) => question.id === dataItem.id
        // );
        // let questionRemoved = questionBasic[0].questionsLevel3.splice(
        //   indexRemove,
        //   1
        // );
        questionSelect[0].questionGroup = questionBasic[0].questionGroup;
        questionSelect[0].level = 2;
        questionSelect[0].order = conseNumber1;
        let consecutive1 = conseNumber1
        let consecutive2 = conseNumber2 + 1
        let consecutive3 = 0
        questionSelect[0].consecutive = consecutive1 + "." + consecutive2 + "." + consecutive3;
        // let numberOrder = parseInt(questionBasic[0].questionsLevel2.length);
        // let preOrder4 = `${questionBasic[0].order}.${numberOrder}`
        copyQuestions.splice(index, 1, questionSelect[0]);
      } else if (dataItem.level === 2) {
        // let indexRemove = questionBasic[0].questionsLevel2.findIndex(
        //   (question) => question.id === dataItem.id
        // );
        // let questionRemoved = questionBasic[0].questionsLevel2.splice(
        //   indexRemove,
        //   1
        // );
        questionSelect[0].level = 1;
        questionSelect[0].order = conseNumber1 + 1;
        questionSelect[0].questionGroup = questionSelect[0].question + questionSelect[0].order;
        let consecutive1 = conseNumber1 + 1
        let consecutive2 = 0
        let consecutive3 = 0
        questionSelect[0].consecutive = consecutive1 + "." + consecutive2 + "." + consecutive3;
      } else {
        return;
      }

      let count = 0;
      for (let i = 0; i < copyQuestions.length; i++) {
        if (copyQuestions[i].level === 1) {
          let numberConsec1 = count + 1
          let numberConsec2 = 0
          let numberConsec3 = 0
          copyQuestions[i].consecutive = numberConsec1 + '.' + numberConsec2 + '.' + numberConsec3;
          count++;
        }
      }
      copyQuestions.splice(index, 1, questionSelect[0]);
      updateOrderIdLevelQuestions(copyQuestions, questionsBefore, consecutivesQuestions)
    }

    // orderJsonByQuestions(copyQuestions)
  };


  //function to order json to send by questions moved in grid
  const orderJsonByQuestions = (questions) => {
    let copyQuestions = [...allInfoQuestionToSend.questionAnswer]
    let allQuestionAnswers = {
      "questionAnswer": []
    }
    for (let index = 0; index < copyQuestions.length; index++) {
      copyQuestions[index].question = questions[index]
    }

    allQuestionAnswers.questionAnswer = copyQuestions

    // const questionJson =  JSON.stringify(allQuestionAnswers)
    // setAllInfoQuestionToSendStirng(questionJson);
    setAllInfoQuestionToSend(allQuestionAnswers);
  }

  // //do like a rollback about info quetions
  // useEffect(() => {
  //   if(errorInfoQuestions === true && questionsBeforeSend){
  //     for (let i = 0; i < questionsBeforeSend.length; i++) {
  //       questionsBeforeSend[i].order = i + 1
  //       questionsBeforeSend[i].level = 1        
  //     }
  //     setQuestions(questionsBeforeSend);
  //   }
  // }, [errorInfoQuestions, questionsBeforeSend])


  const closeDialogDeleteQuestion = () => {
    setShowDeleteQuestion(false)
  }
  const openShowDialogDeleteQuestion = (dataItem) => {
    setShowDeleteQuestion(true)
    setQuestionToDelete(dataItem)
  }


  //delete question by id 
  const handleModalDeleteQuestion = async () => {
    setShowDeleteQuestion(false)
    await toggleLoadingRequesting(true);
    let copyQuestions = [...questions]
    let idsQuestionsToDelete = []
    let id = 0

    let questionsToDelete = copyQuestions.filter((question) => question.questionGroup === questionToDelete.questionGroup)
    if (questionToDelete.level === 1) {
      id = questionToDelete.id
    } else {
      id = questionsToDelete[0].id
    }

    if (questionsToDelete.length > 1) {
      for (let index = 0; index < questionsToDelete.length; index++) {
        if (index > 0) {
          idsQuestionsToDelete.push(questionsToDelete[index].id)
        }
      }
    }

    let idsQuestionsString = JSON.stringify(idsQuestionsToDelete)

    try {
      let questionnaireService = new QuestionnaireService(process.env.REACT_APP_MIFIRMA_API);
      //delete question or questions
      let questionsDeleted = await questionnaireService.deleteQuestion(id, idsQuestionsString, token)
      if (questionsDeleted && Number(questionsDeleted.statusCode) === 200) {
        //get questions order
        let questionnaireId = selectedQuestionnaire.id
        let completeInfoQuestions = await questionnaireService.getCompleteInfoQuestions(questionnaireId, token)
        let questionsToShowCompelte = []
        for (let index = 0; index < completeInfoQuestions.data.length; index++) {
          if (completeInfoQuestions && completeInfoQuestions.data && index > 0 && completeInfoQuestions.data[index].Question) {
            questionsToShowCompelte.push(completeInfoQuestions.data[index].Question)
          }
        }

        //set questions
        let userId = user.userMetaData.userA3Cloud.clientId;
        let contractService = new ContractService(process.env.REACT_APP_MIFIRMA_API);
        setQuestions(questionsToShowCompelte);
        setAllInfoQuestionToSend(questionsToShowCompelte)
        getAllVarsUseInQuestions(questionsToShowCompelte);
        let questionnaires = await contractService.getQuestionnairesByUserId(
          token,
          userId
        );
        await toggleLoadingRequesting(false);
        await toggleCompletedRequesting(true, "", questionnaires.data.data);
      } else {
        await toggleLoadingRequesting(false);
        await toggleErrorRequesting(true)
        setTimeout(() => {
          toggleErrorRequesting(false)
          setNameComponentUser(t("questionnairesAdministrationView.btn.adm.questions.grid"));
          setShowDetails(true);
        }, 3000);
      }
      // setQuestions(newQuestions)
    } catch (error) {
      await toggleLoadingRequesting(false);
      await toggleErrorRequesting(true)
      setTimeout(() => {
        toggleErrorRequesting(false)
        setNameComponentUser(t("questionnairesAdministrationView.btn.adm.questions.grid"));
        setShowDetails(true);
      }, 3000);
    }
  }

  //function to save id question, order, level and consecutive
  const updateOrderIdLevelQuestions = async (questions, beforeQuestions, consecutivesQuestions) => {
    let idsLevelsOrder = []
    for (let index = 0; index < questions.length; index++) {
      let info = {
        id: 0,
        order: 0,
        level: 0,
        consecutive: 0
      }
      let orderSplit = questions[index].consecutive.split('.')
      let order = Number(orderSplit[0])
      info.questionId = questions[index].id
      info.level = questions[index].level
      info.order = order
      info.consecutive = questions[index].consecutive
      info.questionGroup = questions[index].questionGroup
      idsLevelsOrder.push(info)
    }

    let questionArray = JSON.stringify(idsLevelsOrder)


    let questionnaireService = new QuestionnaireService(process.env.REACT_APP_MIFIRMA_API);
    try {
      let questionsUdpated = await questionnaireService.updateOrderQuestion(questionArray, token)
      if (questionsUdpated && Number(questionsUdpated.statusCode) === 200) {
        setQuestions(questions);
      } else {
        //rollback en el front
        let questionnaireId = selectedQuestionnaire.id
        let completeInfoQuestions = await questionnaireService.getCompleteInfoQuestions(questionnaireId, token)
        let questionsToShowCompelte = []
        for (let index = 0; index < completeInfoQuestions.data.length; index++) {
          if (completeInfoQuestions && completeInfoQuestions.data && index > 0 && completeInfoQuestions.data[index].Question) {
            questionsToShowCompelte.push(completeInfoQuestions.data[index].Question)
          }
        }

        //set questions
        setQuestions(questionsToShowCompelte);
        setAllInfoQuestionToSend(questionsToShowCompelte)
        getAllVarsUseInQuestions(questionsToShowCompelte);
      }
    } catch (error) {
      //rollback en el front
      let questionnaireId = selectedQuestionnaire.id
      let completeInfoQuestions = await questionnaireService.getCompleteInfoQuestions(questionnaireId, token)
      let questionsToShowCompelte = []
      for (let index = 0; index < completeInfoQuestions.data.length; index++) {
        if (completeInfoQuestions && completeInfoQuestions.data && index > 0 && completeInfoQuestions.data[index].Question) {
          questionsToShowCompelte.push(completeInfoQuestions.data[index].Question)
        }
      }

      //set questions
      setQuestions(questionsToShowCompelte);
      setAllInfoQuestionToSend(questionsToShowCompelte)
      getAllVarsUseInQuestions(questionsToShowCompelte);

    }

  }

  return showGettingData ? (
    <div className="questionnairesAdministrationNewQuestionnaireView-loader">
      <SimpleLoading />
    </div>
  ) : (
    <>

      <Grid
        item
        lg={12}
        md={12}
        sm={12}
        xs={12}
        className="questionnairesAdministrationManageQuestionsView-wrapper"
      >
        {showLoadingRequesting ? <DialogSystemGLPure toggleLoadingRequesting={toggleLoadingRequesting} showLoadingRequesting={showLoadingRequesting} /> : null}
        {showCompletedRequesting ? (<DialogSystemGLPure showCompletedRequesting={showCompletedRequesting} toggleCompletedRequesting={toggleCompletedRequesting} />) : null}
        {showErrorRequesting ? <DialogSystemGLPure toggleErrorRequesting={toggleErrorRequesting} showErrorRequesting={showErrorRequesting} /> : null}

        <Grid
          item
          lg={12}
          md={12}
          sm={12}
          xs={12}
          className="questionnairesAdministrationManageQuestionsView-navbar"
        >
          <ButtonAddHLPure
            iconAdd={true}
            nameBtn={t(
              "questionnairesAdministrationManageQuestionsView.btn.add.question"
            )}
            onClickBtn={() => {
              setNameComponentUser(t("questionnairesAdministrationView.header.title.add.question"));
              setShowDetails(true);
            }}
          />
          {/* <div className="questionnairesAdministrationView-seach-input-btn">
            <TextBoxHLPure
              textBox={`${t(
                "questionnairesAdministrationManageQuestionsView.label.vars.template"
              )} ${templateVarNumbers}`}
            />
          </div>

          <div className="questionnairesAdministrationView-search-filter-btn">
            <TextBoxHLPure
              textBox={`${t(
                "questionnairesAdministrationManageQuestionsView.label.vars.used"
              )} ${useVarNumbers}`}
            />
          </div> */}
          {/* <div className="questionnairesAdministrationView-seach-input-btn">
            <TextBoxHLPure
              textBox={`${t(
                "questionnairesAdministrationManageQuestionsView.label.vars.template"
              )} ${templateVarNumbers}`}
            />
          </div> */}
          <div className="questionnairesAdministrationViewcard-heightContainer">
            <CardCircularProgressBarHLPure text={`${t(
              "questionnairesAdministrationManageQuestionsView.label.vars.template"
            )}:`} valueChart={Math.round((100 * templateVarNumbers) / templateVarNumbers)}
              text2={templateVarNumbers}
              styleMobile
            />
          </div>
          <div className="questionnairesAdministrationViewcard-heightContainer">
            <CardCircularProgressBarHLPure text={`${t(
              "questionnairesAdministrationManageQuestionsView.label.vars.used"
            )}:`} valueChart={Math.round((100 * useVarNumbers) / templateVarNumbers)}
              // text2={Math.round((100 * useVarNumbers) / templateVarNumbers) || 0}
              text2={useVarNumbers}
              styleMobile
            />
          </div>
        </Grid>
        {/* <Grid item className="questionnairesDigitalContractView-gridTable">
          <GridHLPure
            dataGrid={questions}
            skip={0}
            take={5}
            titleRow1={"Preguntas"}
            titleRow4={t("questionnairesAdministrationView.accions.title.grid")}
            fieldRow1={"question"}
            fieldTitle={"dato"}
            fieldSubtitle={"dato"}
            textSubtitle={"Tipo: Pregunta"}
            onSelectedItem={setselectedQuestions}
            setShowDetails={setShowDetails}
            setNameComponentUser={setNameComponentUser}
            column2Status={false}
            iconOneActive
            iconTwoActive
            labelOneActions={"Eliminar pregunta"}
            labelTwoActions={"Editar pregunta"}
            // styleCol1 = {"gridHLPure-cellItemStyleCol1"}
            // styleCol4= {"gridHLPure-cellItemStyleCol4"}
            columnFour
            btnOpenDialog1 = {false}
          />
        </Grid> */}
        <QuestionsPure
          validateInput={ValidateInputPure}
          // setSigners={setSigners}
          isSignatureTypeSelected={true}
          isAtgrafSignature={false}
          signers={questions.map((item) => ({
            ...item,
            key: "signers",
          }))}
          // DragCell={props.DragCell}
          changeRows={(dataItem, sum) => changeUpDownRows(dataItem, sum)}
          changeRowsLeftRigth={(dataItem, sum) =>
            changeRightLeftRows(dataItem, sum)
          }
          toggleDeleteQuestion={(dataItem) => openShowDialogDeleteQuestion(dataItem)}
          toggleEditQuestion={(dataItem) => {
            setselectedQuestions(dataItem)
            setNameComponentUser(t("questionnairesAdministrationEditDetailView.btn.edit.question"));
            setShowDetails(true);
          }}
        />
        <Grid
          item
          lg={12}
          md={12}
          sm={12}
          xs={12}
          className="questionnairesAdministrationManageQuestionsView-container-btn"
        >
          <ButtonHLPure
            nameBtn={t("button.return")}
            primary
            onClickBtn={hideShowDetails}
          />
        </Grid>
      </Grid>
      {showDialogDeleteQuestion && (
        <DialogYesNoHLPure
          cancel={closeDialogDeleteQuestion}
          textBtnCancel={t("button.cancel")}
          saveBtn={t("followUpActionsContractsView.button.delete")}
          titleDialog={t('dialogSignRequestPure.titleDialogSignRequest')}
          loadingComponent={isLoading}
          handleSubmit={handleModalDeleteQuestion}
        >
          {/* <h1>{t('questionnairesAdministrationManageQuestionsView-dialog-delete-question-description')}</h1>
          <div className="questionnairesAdministrationManageQuestionsView-dialog-delete-question-description">
            <h4> {t('questionnairesAdministrationManageQuestionsView.dialog.delete.question.description')}</h4>
          </div> */}
          <div className="questionnairesAdministrationManageQuestionsView-modal-delete">
            <LabelModalPure label={t('questionnairesAdministrationManageQuestionsView-dialog-delete-question-description')} />
            <LabelModalPure label={t('questionnairesAdministrationManageQuestionsView.dialog.delete.question.description')} />
          </div>
        </DialogYesNoHLPure>
      )}
    </>
  );

};

export default QuestionnairesAdministrationManageQuestionsView;
